interface Dataprops {
  province?: string;
  city?: string;
  area?: string;
  town?: string|undefined;
}
export default function (data:Dataprops){
  let adress = {}
  const province = data.province ? data.province.split('_') : [];
  adress['provinceCode'] = province[1] || "";
  adress['provinceName'] = province[0] || "";
  const city = data.city ? data.city.split('_') : [];
  adress['cityCode'] = city[1] || "";
  adress['cityName'] = city[0] || "";
  const area = data.area ? data.area.split('_') : [];
  adress['areaCode'] = area[1] || "";
  adress['areaName'] = area[0] || "";
  const town = data.town ? data.town.split('_') : [];
  adress['townCode'] = town[1] || "";
  adress['townName'] = town[0] || "";
  delete data['province'];
  delete data['city'];
  delete data['area'];
  delete data['town'];
  return adress
}